import { Check, Package, CreditCard, Truck, Bike, Home, XCircle } from "lucide-react";

const STEPS = [
  ["placed", "Order placed", Package],
  ["paid", "Payment confirmed", CreditCard],
  ["shipped", "Shipped", Truck],
  ["out_for_delivery", "Out for delivery", Bike],
  ["delivered", "Delivered", Home],
];

export const OrderTimeline = ({ order }) => {
  const tl = order.timeline || [];
  const at = (s) => tl.find((t) => t.status === s);
  if (at("cancelled")) {
    return <div className="flex items-center gap-2 text-sm text-red-600 mt-4" data-testid={`timeline-cancelled-${order.order_id}`}><XCircle className="w-4 h-4" /> Order cancelled {at("cancelled").note && `· ${at("cancelled").note}`}</div>;
  }
  const doneIdx = STEPS.reduce((m, [s], i) => (at(s) ? i : m), 0);
  return (
    <div className="mt-5" data-testid={`order-timeline-${order.order_id}`}>
      <div className="flex items-start">
        {STEPS.map(([s, label, Icon], i) => {
          const done = i <= doneIdx && at(s);
          const ev = at(s);
          return (
            <div key={s} className="flex-1 flex flex-col items-center text-center relative" data-testid={`timeline-step-${s}`}>
              {i > 0 && <div className={`absolute top-4 right-1/2 w-full h-0.5 ${i <= doneIdx ? "bg-[#1E5E3A]" : "bg-stone-200"}`} />}
              <div className={`relative z-10 w-8 h-8 rounded-full grid place-items-center transition-colors ${done ? "bg-[#1E5E3A] text-white" : "bg-stone-100 text-stone-400"}`}>
                {done ? <Check className="w-4 h-4" /> : <Icon className="w-4 h-4" />}
              </div>
              <p className={`text-[11px] sm:text-xs mt-2 font-semibold ${done ? "text-[#1A1714]" : "text-stone-400"}`}>{label}</p>
              {ev && <p className="text-[10px] text-stone-400 hidden sm:block">{new Date(ev.at).toLocaleDateString()}</p>}
            </div>
          );
        })}
      </div>
      {order.tracking_number && <p className="text-xs text-stone-600 mt-4" data-testid={`tracking-number-${order.order_id}`}>Tracking number: <span className="font-mono font-semibold">{order.tracking_number}</span></p>}
    </div>
  );
};
